import { ajax_loadmore_gallery_items } from './infiniteScroll';
import PhotoSwipeLightbox from '../_vendors/photoswipe-lightbox.esm';
import PhotoSwipeVideoPlugin from '../_vendors/photoswipe-video-plugin.esm';
import PhotoSwipeDynamicCaption from '../_vendors/photoswipe-dynamic-caption-plugin.esm';
import PhotoSwipe from '../_vendors/photoswipe.esm';

export function theme_photoswipe() {

	const options = {
		gallery: '#photoswipe-gallery',
		children: 'a.album-thumb:not(.is-protected)',
		pswpModule: PhotoSwipe,
		closeOnScroll: false,
		showAnimationDuration: 0,
		hideAnimationDuration: 0,
		initialZoomLevel: 'fit',
		secondaryZoomLevel: 'fit',
		zoom: false,
		counter: false,
		loop: false,
		paddingFn: ( viewportSize, itemData, index ) => {
			return {
				top: viewportSize.x < 480 ? 46 : 60,
				bottom: viewportSize.x < 480 ? 46 : 60,
				left: viewportSize.x < 480 ? 20 : 50,
				right: viewportSize.x < 480 ? 20 : 50
			};
		},
		bgOpacity: 1,
	};

	const lightbox = new PhotoSwipeLightbox(options);
	const videoPlugin = new PhotoSwipeVideoPlugin(lightbox);
	const captionPlugin = new PhotoSwipeDynamicCaption(lightbox, {
		asidePosition: 'bottom'
	});

	lightbox.on( 'change', () => {

		let total = lightbox.getNumItems();
		let current = lightbox.pswp.currSlide.index;

		if ( current + 5 > total && data_params.current_page < data_params.max_page ) {
			// trigger loadmore
			ajax_loadmore_gallery_items( lightbox.pswp.options.dataSource );
		}

	});

	lightbox.init();

}
